var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 407 421",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-757,-330)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M818.67,595.66C781.61,595.66 767.28,581.02 767.28,544.58L767.28,536.96C767.28,500.52 781.61,485.88 818.67,485.88L823.82,485.88C859.48,485.88 871.77,500.52 875,527.65L844.47,527.65C843.32,513.81 834.8,510.28 823.21,510.28L819.44,510.28C800.07,510.28 797.48,520.8 797.48,538.03L797.48,543.52C797.48,560.75 800.07,571.27 819.44,571.27L823.21,571.27C834.8,571.27 843.32,567.53 844.47,553.9L875,553.9C872.28,583.23 856.3,595.67 823.82,595.67L818.67,595.67L818.67,595.66Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M818.54,450.93C788.96,450.93 770.35,441.48 768.07,418.6L799.64,418.6C801.78,427.14 815.26,428.51 824.87,428.51C837.07,428.51 844.25,425.46 844.25,418.29L844.25,416.77C844.25,410.67 839.35,408.08 828.22,407.62L806.97,407.16C780.74,406.25 768.7,397.4 768.7,376.81L768.7,376.05C768.7,353.02 783.49,341.13 814.75,341.13L822.88,341.13C851.85,341.13 870.15,353.18 872.13,374.83L840.56,374.83C838.42,366.29 830.33,363.55 820.26,363.55C808.82,363.55 797.49,363.59 797.49,373.77L797.49,374.38C797.49,380.78 802.24,383.38 813.37,383.68L834.62,384.29C860.85,385.2 872.9,394.05 872.9,414.64L872.9,415.71C872.9,440.87 855.52,450.94 825.17,450.94L818.54,450.94L818.54,450.93Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M947.33,449.41L947.33,368.13L911.34,368.13L911.34,342.66L1014.44,342.66L1014.44,368.13L977.37,368.13L977.37,449.41L947.33,449.41Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1126.76,449.41L1119.44,427.91L1076.9,427.91L1069.58,449.41L1037.71,449.41L1076.44,342.67L1121.27,342.67L1160,449.41L1126.76,449.41ZM1084.52,404.73L1111.82,404.73L1098.71,366.15L1097.64,366.15L1084.52,404.73Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M920.7,594.15L920.7,487.39L950.44,487.39L950.44,530.39L951.51,530.39L990.55,487.39L1027.3,487.39L986.89,530.09L1028.37,594.14L991.77,594.14L964.93,552.21L963.86,552.21L950.44,566.24L950.44,594.15L920.7,594.15Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M849.05,738.86L841.73,717.36L799.19,717.36L791.87,738.86L760,738.86L798.73,632.12L843.56,632.12L882.29,738.86L849.05,738.86ZM806.81,694.18L834.11,694.18L821,655.6L819.93,655.6L806.81,694.18Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987.31,738.86L921.72,738.86L921.72,632.12L985.64,632.12C1014.46,632.12 1023.46,641.57 1023.46,659.26L1023.46,660.63C1023.46,673.74 1018.43,681.98 1005.01,683.66L1005.01,684.73C1019.65,686.1 1024.83,694.18 1024.83,707.76L1024.83,709.89C1024.83,729.25 1015.07,738.86 987.31,738.86ZM951.46,675.12L981.68,675.12C990.83,675.12 993.42,673.44 993.42,665.82L993.42,665.21C993.42,657.59 990.83,655.15 980.15,655.15L951.46,655.15L951.46,675.12ZM951.46,694.64L951.46,715.84L980,715.84C991.89,715.84 994.94,713.71 994.94,705.62L994.94,704.55C994.94,696.16 992.04,694.64 979.69,694.64L951.46,694.64Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1069.26,738.87L1069.26,632.12L1099,632.12L1099,713.4L1151.77,713.4L1151.77,738.87L1069.26,738.87Z",
    style: {
      fillRule: "nonzero"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.f5a282b4.svg";
export { ForwardRef as ReactComponent };